<div fxLayout="row" fxLayoutAlign="start center" fxFlexFill>
  <div
    fxLayout="column"
    fxFlex="{{ maxLength ? '70%' : '100%' }}"
    fxLayoutAlign="start start"
  >
    @if(control?.touched && !!error) {
    <div>
      {{ 'error-message-wrapper.text.' + error.type | translate : error.data }}
    </div>
    }
  </div>

  @if (maxLength) {
  <div fxLayout="column" fxFlex="30%" fxLayoutAlign="start end">
    {{ control?.value?.length || '0' }} / {{ maxLength }}
  </div>
  }
</div>
